import EventCard from '../components/EventCard';
import { S } from '../components/styles';

const fmtDate = d => new Date(d).toLocaleDateString('en-US',{month:'short',day:'numeric',year:'numeric'});

export default function EventsView({ events, onNavigate, profile }) {
  const upcoming = events.filter(e => e.status === 'upcoming');
  return (
    <div>
      <div style={S.pageHero}><h2 style={S.h2}>All Events</h2><p style={S.textMuted}>Parties you're hosting or attending</p></div>
      <div style={S.content}>
        {upcoming.length === 0 && (
          <div style={S.empty}><div style={{fontSize:52,marginBottom:16}}>📅</div><h3 style={{fontFamily:'Cormorant Garamond,serif',fontSize:24,marginBottom:8}}>Nothing on the calendar</h3><p style={{color:'#7A6555',fontSize:14}}>Host or get invited to a dinner party to see it here.</p></div>
        )}
        <div style={{display:'flex',flexDirection:'column',gap:14}}>
          {upcoming.map(ev => (
            <div key={ev.id} style={{...S.card,display:'flex',cursor:'pointer',overflow:'hidden',minHeight:90,transition:'all .2s'}} onClick={()=>onNavigate('event',ev.id)}
              onMouseEnter={e=>{e.currentTarget.style.boxShadow='0 4px 20px rgba(44,26,14,.12)';}}
              onMouseLeave={e=>{e.currentTarget.style.boxShadow='none';}}>
              <div style={{width:100,background:ev.banner_bg||'#3E2723',display:'flex',alignItems:'center',justifyContent:'center',fontSize:38,flexShrink:0}}>{ev.emoji}</div>
              <div style={{padding:'14px 18px',flex:1}}>
                <div style={{display:'flex',gap:8,alignItems:'center',marginBottom:6}}>
                  <h4 style={{fontFamily:'Cormorant Garamond,serif',fontSize:17}}>{ev.title}</h4>
                  {ev.host_id===profile?.id && <span style={{padding:'2px 8px',borderRadius:12,fontSize:11,background:'#FAEEE8',color:'#7B2D0D',fontWeight:500}}>Hosting</span>}
                </div>
                <p style={{fontSize:13,color:'#7A6555',marginBottom:6}}>{fmtDate(ev.date)} · {ev.time} · {ev.address}</p>
                <p style={{fontSize:13,fontStyle:'italic',color:'#7A6555'}}>{ev.theme?.slice(0,70)}{ev.theme?.length>70?'…':''}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
